import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "event_place",
})
export class EventPlace implements PipeTransform {
  transform(event: any): string {
    if (event) {
      if (event.cons_circle_id != -1) {
        var label = "";
        if (event.section_name != -1) {
          label = event.section_name;
          label += ", ";
        }

        label += event.union_name + " (" + event.union_type_name + ")";

        return label;
      } else if (event.Const_name) {
        return event.Const_name + " (தொகுதி)";
      }
    }
  }
}

@Pipe({
  name: "event_organizer",
})
export class EventOrganizer implements PipeTransform {
  transform(organizers: any, organizer_type: number): any[] {

    if (organizers) {
      return organizers.filter((object: { participant_type: number }) => {
        return object.participant_type == organizer_type;
      });
    }
  }
}
